import { Link } from "react-router-dom"

const LinkPage = () => {
    return (
        <div className="fade-in" style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem",
            background: "var(--bg-dark)"
        }}>
            <div style={{ textAlign: "center", marginBottom: "4rem" }}>
                <h1 style={{
                    fontSize: "4rem",
                    fontWeight: "800",
                    marginBottom: "1rem",
                    background: "linear-gradient(135deg, var(--primary-purple), var(--accent-cyan))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    letterSpacing: "-0.02em"
                }}>
                    Psychometric Assessment
                </h1>
                <p style={{ color: "var(--text-muted)", fontSize: "1.25rem", maxWidth: "600px", margin: "0 auto" }}>
                    A modern platform for personality analysis and assessment management.
                </p>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "2rem", maxWidth: "900px", width: "100%" }}>
                <div className="card" style={{ padding: "2.5rem", textAlign: "center", transition: "transform 0.2s" }}>
                    <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1rem", color: "var(--text-primary)" }}>Get Started</h2>
                    <p style={{ color: "var(--text-secondary)", marginBottom: "2rem" }}>
                        New to the platform? Create an account to start managing assessments.
                    </p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                        <Link to="/login" className="btn-primary" style={{ textDecoration: "none", display: "block" }}>Login</Link>
                        <Link to="/register" className="btn-secondary" style={{ textDecoration: "none", display: "block" }}>Register</Link>
                    </div>
                </div>

                <div className="card" style={{ padding: "2.5rem", textAlign: "center", transition: "transform 0.2s" }}>
                    <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1rem", color: "var(--text-primary)" }}>Quick Access</h2>
                    <p style={{ color: "var(--text-secondary)", marginBottom: "2rem" }}>
                        Direct links to key areas of the application.
                    </p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                        <Link to="/" className="btn-secondary" style={{ textDecoration: "none", display: "block" }}>Home Dashboard</Link>
                        <Link to="/admin" className="btn-secondary" style={{ textDecoration: "none", display: "block" }}>Admin Portal</Link>
                    </div>
                </div>
            </div>

            <footer style={{ marginTop: "4rem", color: "var(--text-muted)", fontSize: "0.875rem" }}>
                &copy; {new Date().getFullYear()} Psychometric Assessment Platform. All rights reserved.
            </footer>
        </div>
    )
}

export default LinkPage
